import { getDeviceType, getDeviceData, getUserAgent } from '../globals/utilities/GetDeviceType';
import { getAppType } from '../globals/utilities/isMobileApp';

export default class PushNotifications {
	Config = {
		'oferteo.pl': {
			apiKey: 'AIzaSyCPIOzjsNBTXzmgNmjV41dIIhGR6lmZGTE',
			authDomain: 'oferteopwa.firebaseapp.com',
			databaseURL: 'https://oferteopwa.firebaseio.com',
			projectId: 'oferteopwa',
			storageBucket: 'oferteopwa.appspot.com',
			messagingSenderId: '505189348914',
			publicVapidKey: 'BOXnP8hBtVcFj3jDeHhe6eIZKAqa-YRK9UOfW2LThs6g7eYCP5ia0LG6GkGf-UzPRW786eyIbw2PHWp2cQdjxbI',
		},
		'oferteo-fix.pl': {
			apiKey: 'AIzaSyBHLzbAeVwjokJXBFl61knRYQ7pv893fKY',
			authDomain: 'oferteopwa-fix.firebaseapp.com',
			databaseURL: 'https://oferteopwa-fix.firebaseio.com',
			projectId: 'oferteopwa-fix',
			storageBucket: 'oferteopwa-fix.appspot.com',
			messagingSenderId: '242949374194',
			publicVapidKey: 'BISA7abLkbtAK85mjyk3WYXVcSVFLwa5tK9vt0c8H8wp9ctKLTrsugHDlgq_eCcGnZ3gOvc_1FH0OC_ZknEj37U',
		},
		'oferteo-pre.pl': {
			apiKey: 'AIzaSyABNKSendiJkq8XRMY7az_4zGwHPUHk_UU',
			authDomain: 'oferteopwa-pre.firebaseapp.com',
			databaseURL: 'https://oferteopwa-pre.firebaseio.com',
			projectId: 'oferteopwa-pre',
			storageBucket: 'oferteopwa-pre.appspot.com',
			messagingSenderId: '444975520293',
			publicVapidKey: 'BMHjzqkOFT6hPn4pm8RyAsrA9xIjTm76TErsYGrCTyBsRnj7gkLx9tJkyENYnBOPIsoRZlehcyeoPZRESSAQyUw',
		},
		'oferteo-tst.pl': {
			apiKey: 'AIzaSyDugS-zU2J95K-f_DAS5Rl44gsG22VCxIs',
			authDomain: 'oferteopwa-tst.firebaseapp.com',
			databaseURL: 'https://oferteopwa-tst.firebaseio.com',
			projectId: 'oferteopwa-tst',
			storageBucket: 'oferteopwa-tst.appspot.com',
			messagingSenderId: '443008201541',
			publicVapidKey: 'BF0C9TZFevkVBSbxdFcKyGvyuzCiFhNzdlD0Dh0bJ4Yc_oOHtHWU1Qhu6mXeV5ltowQVmQDfmWAMyS-eJz2v1Cw',
		},
		'oferteo-dev.pl': {
			apiKey: 'AIzaSyDMOqylp0JnoUDGHmH4CnnWDXOnYKSB-gQ',
			authDomain: 'oferteopwa-dev.firebaseapp.com',
			databaseURL: 'https://oferteopwa-dev.firebaseio.com',
			projectId: 'oferteopwa-dev',
			storageBucket: 'oferteopwa-dev.appspot.com',
			messagingSenderId: '518826271146',
			publicVapidKey: 'BHrbBNyJTFOuc_wNCnSQ3zqJ69oKszUYRfVtyyGNKGK5x_VetY_IxDfi0toPrTgt5XYwlte8nhtM-5wMU-M-b6s',
		},
	};

	Messaging = null;

	UserId = null;

	Token = null;

	App = null;

	RequestPermissionCallback = null;
	constructor(userId, frontEndDebug = false, appType,  url = '') {
		frontEndDebug = false;
		//console.log("constructor PushNotifications userId:" + userId + ", frontEndDebug:" + frontEndDebug, + ", url:" + url);
		const config = this.GetConfig();
		this.UserId = userId;
		window.setTimeout(() => {
			try {
				if (appType === 'default') {
					if (!firebase.apps.length) {
						firebase.initializeApp(config);
					}
					this.Messaging = firebase.messaging();
				}
				this.GetToken(this.UserId, frontEndDebug);
			} catch (err) {
				console.warn(err);
			}
		}, 100);
	}

	TokenRefresh() {
		console.log('TokenRefresh');
	}

	async AskAndSubscribePush(userId, frontEndDebug = false) {
		const appType = await getAppType();
		if (appType === 'default') {
			if (!this.Messaging) {
				window.setTimeout(() => {
					this.AskAndSubscribePush(userId, frontEndDebug);
				}, 1500);
				return;
			}
			this.Dim('show');
			try {
				if (frontEndDebug) {
					alert('AskAndSubscribePush userId:' + userId);
				}
				if (this.Messaging && typeof this.Messaging.requestPermission !== 'undefined') {
					try {
						await this.Messaging.requestPermission();
						this.Dim('hide');
					} catch (err) {
						this.Dim('hide');
					}
				} else {
					if (frontEndDebug) {
						alert('Request permission method is undefined');
					}
				}
				this.Dim('hide');
			} catch (err) {
				this.Dim('hide');
				console.warn('Zgoda na powiadomienia nie została udzielona');
			}
		}
	}

	Dim(method = 'show') {
		document.querySelector('.is-dimmed').style.display = (method === 'show' ? 'block' : 'none');
	}

	async SubscribeUserPushToken(userId:number|null, token:string|null) {
		const appType = await getAppType();
		const url = `/push/json/subscribe.ofer?userPushToken.idUser=${userId}&userPushToken.token=${token}&userPushToken.deviceData=${getDeviceData()}&userPushToken.agent=${getUserAgent()}&userPushToken.deviceType=${getDeviceType()}&userPushToken.appType=${appType}`;
		await fetch(url);
	}

	async EmptyToken(userId:number|null) {
		const appType = await getAppType();
		const url = `/push/json/emptyToken.ofer?userPushToken.idUser=${userId}&userPushToken.deviceData=${getDeviceData()}&userPushToken.agent=${getUserAgent()}&userPushToken.deviceType=${getDeviceType()}&userPushToken.appType=${appType}`;
		await fetch(url);
	}

	async GetToken(userId:number, frontEndDebug = false) {
		//console.log("GetToken userId:" + userId + ", frontEndDebug:" + frontEndDebug + " START");
		if (frontEndDebug) {
			alert('GetToken userId:' + userId);
		}

		// get Token from mobileApp
		if (typeof getFCMtoken !== 'undefined') {
			if (frontEndDebug) { alert('getFCMtoken != undefined'); }
			this.Token = await getFCMtoken();
			if (frontEndDebug) { alert('this.Token:' + this.Token); }
			if (this.Token) {
				if (frontEndDebug) { alert('SubscribeUserPushToken userId:' + userId + ', this.Token:' + this.Token); }
				await this.SubscribeUserPushToken(userId, this.Token);
				if (frontEndDebug) { alert('SubscribeUserPushToken ok'); }
				return this.Token;
			} else {
				await this.EmptyToken(userId);
			}
		}

		if (frontEndDebug) {
			alert('this.Token:' + this.Token);
		}

		// get token from browser
		if (!this.Token) {
			if (frontEndDebug) {
				alert('Notification.permission:' + Notification.permission);
			}
			if (Notification.permission === 'granted') {
				if (!this.Messaging.publicVapidKey) {
					const config = this.GetConfig();
					this.Messaging.usePublicVapidKey(config.publicVapidKey);
				}

				if (frontEndDebug) {
					alert('this.Messaging.getToken() START');
				}
				await this.Messaging.getToken().then(async (token: string) => {
					if (frontEndDebug) {
						alert('this.Messaging.getToken() token:' + token);
					}
					if (token) {
						this.Token = token;
						await this.SubscribeUserPushToken(userId, token);
					} else {
						console.warn('GetToken(), No token available from Messaging.getToken()');
					}
				}).catch((err) => {
					console.warn('GetToken(), Error retrieving token from Messaging.getToken()', err);
				});
				if (frontEndDebug) {
					alert('this.Messaging.getToken() END');
				}
			}
		}
		//console.log("GetToken userId:" + userId + ", frontEndDebug:" + frontEndDebug + " END");
	}

	GetConfig() {
		const url = document.location.href;
		for (const c in this.Config) {
			if (url.indexOf(c) > -1) {
				return this.Config[c];
			}
		}
		return this.Config['oferteo-tst.pl'];
	}
}
